// extracted by mini-css-extract-plugin
export default {"espacamento":"Senha_espacamento__22HcL","label":"Senha_label__8NTWi"};